"use strict";var e={addresses:{"es-PA":{complement:"Complemento: Edificio, Apartamento, Sector"}}};exports.default=e;